"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToBoolean = stringToBoolean;
function stringToBoolean(str, defaultValue = false) {
    if (str === null || str === undefined) {
        return defaultValue;
    }
    return str.trim().toLowerCase() === 'true';
}
